import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapDetail = async (slug: string, type: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.get(`/trap/${type}/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data;
};
